import { Box, Stack } from "@mui/joy";
import ThoughtMapCard from "./ThoughtMapCard";
import { ThoughtMapText } from "./ThoughtMapText";

export default function BeliefTemplete({
  title,
  data,
  placeholder,
  hasConnectionLine,
}: {
  title: string;
  data: { label: string; value: string }[];
  placeholder: string;
  hasConnectionLine?: boolean;
}) {
  return (
    <>
      {hasConnectionLine && (
        <Box
          sx={{ backgroundColor: "background.level3" }}
          className="w-[2px] h-[20px] mx-auto"
        />
      )}
      <ThoughtMapCard
        label={title}
        content={
          data && data.length > 0 ? (
            <Stack spacing={1}>
              {data.map(({ label, value }, index) => (
                <Stack key={`${label}`} spacing={0.1}>
                  <ThoughtMapText text={label} dimmed color="primary.solid" />
                  <ThoughtMapText text={value} />
                </Stack>
              ))}
            </Stack>
          ) : (
            <ThoughtMapText text={placeholder} dimmed />
          )
        }
        labelBackgroundColor={
          data.length > 0 ? "primary.solid" : "primary.deactivated"
        }
      />
    </>
  );
}
